export default __webpack_public_path__ + "static/media/illustration-elements_token-logo.99d6bc5d.svg";